export default "__VITE_ASSET__C1BF9fuA__"